<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Rate Card Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                v-model="dropDown.selectedCinema"
                :allowEmpty="false"
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                :searchable="true"
                :showLabels="false"
                label="cine_name"
                placeholder="Select Cinema"
                track-by="cine_id"
                @input="onSelectCinema($event)"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button v-if="fromDate" class="btn-clearDate">✖</button>
                <Datepicker
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  :monday-first="true"
                  type="date"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button v-if="toDate" class="btn-clearDate">✖</button>
                <Datepicker
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :monday-first="true"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBoxOfficeSummaryReport"
            >
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="
          (getRateCardStandard.length > 0 ||
            getRateCardredemptions.length > 0 ||
            getRateCardcomplementories.length > 0) &&
          (PDFName || ExcelName)
        "
        class="d-flex justify-content-end my-1 align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
        <a href="#" title="Download as Excel" @click="excelDownload()">
          <img height="25" src="@/assets/img/icons/excel.svg" width="25"/>
        </a>
        -->

        <a
          v-if="PDFName"
          :href="getCinemaBaseURL(this.dropDown.selectedCinemaId) + PDFName"
          download
          target="_blank"
          title="Download as PDF"
        >
          <img height="25" src="@/assets/img/icons/pdf-icon.svg" width="25" />
        </a>

        <a
          v-if="ExcelName"
          :href="getCinemaBaseURL(this.dropDown.selectedCinemaId) + ExcelName"
          download
          target="_blank"
          title="Download as Excel"
        >
          <img height="25" src="@/assets/img/icons/excel.svg" width="25" />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table
            v-if="
              getRateCardStandard.length > 0 ||
              getRateCardredemptions.length > 0 ||
              getRateCardcomplementories.length > 0
            "
            border="1"
            class="swc-report-table swc_table_header"
          >
            <thead class="font-weight-bold bg-lightblue text-light">
              <tr>
                <th colspan="4"></th>
                <th colspan="2">Ticket Sales-Redemptions</th>
              </tr>
              <tr>
                <th colspan="4"></th>
                <th>Seats</th>
                <th>Amounts</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="getRateCardStandard.length > 0">
                <td class="bg-lightgrey text-left font-weight-bold" colspan="6">
                  Standard
                </td>
              </tr>
              <template
                v-for="(standard, standardIndex) in getRateCardStandard"
                v-if="getRateCardStandard.length > 0"
              >
                <tr :key="standardIndex + 'ratestandard'">
                  <td class="text-left" colspan="4">
                    {{ standard.rc_g_name }}
                  </td>

                  <td class="text-right">
                    {{ standard.seats }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(standard.amount) }}
                  </td>
                </tr>
              </template>
              <tr
                v-if="getRateCardStandard.length > 0"
                class="bg-lightgrey font-weight-bold"
              >
                <td class="text-right" colspan="4">Total</td>
                <td class="text-right">
                  {{
                    getRateCardStandard.reduce((acc, { seats }) => {
                      return acc + seats;
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getRateCardStandard.reduce((acc, { amount }) => {
                        return acc + amount;
                      }, 0)
                    )
                  }}
                </td>
              </tr>

              <tr v-if="getRateCardcomplementories.length > 0">
                <td class="bg-lightgrey text-left font-weight-bold" colspan="6">
                  Complimentaries
                </td>
              </tr>
              <template
                v-for="(comp, compIndex) in getRateCardcomplementories"
                v-if="getRateCardcomplementories.length > 0"
              >
                <tr :key="compIndex + 'ratecomp'">
                  <td class="text-left" colspan="4">
                    {{ comp.rc_g_name }}
                  </td>

                  <td class="text-right">
                    {{ comp.seats }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(comp.amount) }}
                  </td>
                </tr>
              </template>
              <tr
                v-if="getRateCardcomplementories.length > 0"
                class="bg-lightgrey font-weight-bold"
              >
                <td class="text-right" colspan="4">Total</td>
                <td class="text-right">
                  {{
                    getRateCardcomplementories.reduce((acc, { seats }) => {
                      return acc + seats;
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getRateCardcomplementories.reduce((acc, { amount }) => {
                        return acc + amount;
                      }, 0)
                    )
                  }}
                </td>
              </tr>

              <tr :class="getRateCardredemptions.length === 0 ? 'd-none' : ''">
                <td class="bg-lightgrey text-left font-weight-bold" colspan="6">
                  Redemptions
                </td>
              </tr>

              <template
                v-for="(redem, redemIndex) in getRateCardredemptions"
                :class="getRateCardredemptions.length === 0 ? 'd-none' : ''"
              >
                <tr :key="redemIndex + 'rateredem'">
                  <td class="text-left" colspan="4">
                    {{ redem.rc_g_name }}
                  </td>

                  <td class="text-right">
                    {{ redem.seats }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(redem.amount) }}
                  </td>
                </tr>
              </template>
              <tr
                :class="getRateCardredemptions.length === 0 ? 'd-none' : ''"
                class="bg-lightgrey font-weight-bold"
              >
                <td class="text-right" colspan="4">Total</td>
                <td class="text-right">
                  {{
                    getRateCardredemptions.reduce((acc, { seats }) => {
                      return acc + seats;
                    }, 0)
                  }}
                </td>
                <td class="text-right">
                  {{
                    currFormat(
                      getRateCardredemptions.reduce((acc, { amount }) => {
                        return acc + amount;
                      }, 0)
                    )
                  }}
                </td>
              </tr>

              <tr
                :key="getgrandTotal + 'rategrandtotal'"
                class="bg-lightgrey font-weight-bold"
              >
                <td colspan="4">Grand Total</td>
                <td class="text-right">{{ getgrandTotal.seatsTotal }}</td>
                <td class="text-right">
                  {{ currFormat(getgrandTotal.grossAmountTotal) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <table
        v-if="
          getRateCardStandard.length === 0 &&
          getRateCardredemptions.length === 0 &&
          getRateCardcomplementories.length === 0
        "
        border="1"
        class="swc-report-table swc_table_header"
      >
        <thead class="font-weight-bold">
          <tr class="bg-lightblue text-light">
            <td colspan="2">Ticket Sales-Redemptions</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="11">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { getCinemaBaseURL } from "@/services/Api"

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      BASEURL,
      FilePathArray: [],
      PDFName: "",
      ExcelName: "",
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: moment().subtract(7, "day").toDate(),
      toDate: new Date(),
      getBoxOfficeReport: [],
      getRateCardStandard: [],
      getRateCardredemptions: [],
      getRateCardcomplementories: [],
      getgrandTotal: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    getCinemaBaseURL,
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getBoxOfficeSummaryReport: function () {
      let loader = this.$loading.show();
      this.PDFName = "";
      this.ExcelName = "";
      this.submitted = true;

      let selectedCinemaId = this.dropDown.selectedCinemaId;
      let selectedCinemaName = this.dropDown.selectedCinemaName;

      let message;

      if (!selectedCinemaId) {
        message = "Please select a cinema";
      } else if (!this.fromDate) {
        message = "From Date field cannot be empty";
      } else if (!this.toDate) {
        message = "To Date field cannot be empty";
      } else if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        message = "To date should be greater than from date";
      }

      if (message) {
        this.$toasted.show(message);
        loader.hide();
        return;
      }

      let payload = {
        cinema_id: selectedCinemaId,
        cinema_name: selectedCinemaName,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
      };
      ReportsService.GetRateCardAnalysisReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.getRateCardStandard = data.standard;
            this.getRateCardredemptions = data.redemptions;
            this.getRateCardcomplementories = data.complementories;
            this.getgrandTotal = data.grandTotal;
          } else {
            this.$toasted.show(data.message);
          }

          if (data.reports && data.reports.pdfPath) {
            this.PDFName = data.reports.pdfPath;
            this.FilePathArray.push(data.reports.pdfPath);
          }
          if (data.reports && data.reports.excelPath) {
            this.ExcelName = data.reports.excelPath;
            this.FilePathArray.push(data.reports.excelPath);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          loader.hide();
        });
    },
    excelDownload() {
      // this.getRateCardStandard=[...this.getRateCardStandard,{test_name:"Standard"}]
      // this.getRateCardredemptions=[...this.getRateCardredemptions,{test_name:"Redemptions"}]
      // this.getRateCardcomplementories=[...this.getRateCardcomplementories,{test_name:"test"}]

      this.getRateCardStandard.map((x) => {
        x["test_name"] = "Standard";
      });
      this.getRateCardcomplementories.map((x) => {
        x["test_name"] = "Complementories";
      });
      this.getRateCardredemptions.map((x) => {
        x["test_name"] = "Redemptions";
      });

      let new_records = [
        ...this.getRateCardStandard,
        ...this.getRateCardcomplementories,
        ...this.getRateCardredemptions,
      ];
      //   let temp_arr = this.getRateCardStandard,
      //   getRateCardredemptions :[],
      //   getRateCardcomplementories:[],;
      //   temp_arr = this.getBoxOfficeReport.map(x => {
      //     x.show_time_array.map(z => {
      //       let obj = {
      //         ...x,
      //         ...z
      //       };
      //       new_records.push(obj);
      //     });
      //   });
      //   console.log("new_records", new_records);
      let data = [
        {
          sheet: "RateCardReport Report",
          columns: [
            {
              value: "test_name",
              label: "",
            },
            {
              value: "rc_g_name",
              label: "Rate Card Type",
            },
            {
              value: "seats",
              label: "Seats",
            },
            {
              value: "amount",
              label: "Amount",
            },

            //      Sold: 0,
            // gross_amount: 0,
            // offer_price: 0,
            // total_taxes: 0,
            // final_gross_amount: 0
          ],
          content: new_records,
        },
      ];

      let cinemaName = this.dropDown.selectedCinemaName;
      let fromDate = this.fromDate
        ? moment(this.fromDate).format("YYYY-MM-DD")
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let settings = {
        fileName: `RateCardReport${cinemaName}_${fromDate}_${toDate}_on${dateTime}`,
      };
      xlsx(data, settings);
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/RateCardReport.vue